import { render, staticRenderFns } from "./PagePermissions.vue?vue&type=template&id=7bc3cd02&scoped=true"
import script from "./PagePermissions.vue?vue&type=script&lang=js"
export * from "./PagePermissions.vue?vue&type=script&lang=js"
import style1 from "./PagePermissions.vue?vue&type=style&index=1&id=7bc3cd02&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bc3cd02",
  null
  
)

export default component.exports